export default {
    methods: {
        clearReadonly(event) {
            event.target.removeAttribute('readonly');
        }
    }
};